<template>
    <div class="relative flex items-start gap-8 py-8 w-full">
        <div v-if="!individual"
            :class="[
                'hidden at1024:block at1024:sticky py-8 px-4 rounded-md bg-gray-150 max-w-[180px] w-[180px]',
                (index === 0 && settings.is_sourcing_mode) ? 'top-24' : 'top-36'
            ]"
        >
            <img
                v-if="manufacturer.logo?.external_id"
                class="mx-auto"
                :src="marketingAssetUrl(manufacturer.logo.external_id, 'man-detail')"
                :alt="manufacturer.name"
            />
        </div>

        <div class="w-full h-full">
            <Link v-if="!individual" :href="route('web.catalog.price-books.show', manufacturer)" class="hover:underline underline-offset-6 inline-block">
                <h2 class="type-primary font-bold text-2xl mb-4">
                    {{ manufacturer.name }}
                </h2>
            </Link>
            <h2 v-else class="type-primary font-bold text-2xl mb-4">
                {{ manufacturer.name }}
            </h2>
            <!-- No price book -->
            <div v-if="!manufacturer.resources['Price Books']?.length">
                <h3 class="text-left mb-4">
                    {{ $t("Call for pricing", { phone: "800-847-5625" }) }}
                </h3>
            </div>
            <div v-for="(section, key) in sortedResources" class="border-t border-keyline-primary">
                <h3 class="text-left mt-4 mb-3 text-lg font-medium" :dusk="`resource-section-${key.toLowerCase().replace(/\s+/g, '-')}`">{{ key }}</h3>
                <ul class="mb-6">
                    <li
                        v-for="file in section?.sort((a, b) => a.name?.localeCompare(b.name))"
                        class="w-full py-2 px-3 hover:bg-gray-tier-5 rounded grid grid-cols-4 items-center justify-start gap-4 mr-16"
                    >
                        <div class="col-span-3 flex items-center gap-4">
                            <BaseSvg
                                class="shrink-0 w-6 h-6 type-tertiary"
                                :name="config.resources.icons[key] ?? 'icon-draft-paper'"
                            />
                            <a
                                :href="marketingAssetUrl(file.asset.external_id)"
                                class="overflow-hidden whitespace-nowrap truncate"
                                target="_blank"
                            >
                                <span class="hover:underline underline-offset-4 decoration-1">{{ file.name }}</span>
                            </a>
                        </div>
                        <div class="hidden at1024:flex items-center justify-end gap-8 whitespace-nowrap col-span-1 ml-auto">
                            <span
                                class="hidden at1200:block type-secondary"
                            >
                                {{ file?.asset?.updated_at ? DateTime.fromISO(file?.asset?.updated_at).toLocaleString(DateTime.DATE_MED) : "–"}}
                            </span>
                            <button
                                class="group"
                                @click.stop.prevent="forceDownload($event, marketingAssetUrl(file.asset.external_id), _.kebabCase(file.name)+'.pdf')"
                            >
                                <BaseSvg
                                    name="icon-export-file"
                                    class="shrink-0 group-hover:fill-red"
                                />
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import { DateTime } from "luxon";
import {BaseSvg, Divider} from "@/Components";
import {useAssetTransforms, useDownload} from "@/Composables";
import _ from 'lodash'
import {computed} from "vue";
import config from "@/config";
import { useUser } from "@/Composables";

const { marketingAssetUrl } = useAssetTransforms();
const { forceDownload } = useDownload();
const { settings } = useUser();
const props = defineProps(["manufacturer", "index", "individual"]);

const sortedResources = computed(() => {
    let sortedKeys = _.sortBy(Object.keys(props.manufacturer.resources));
    return _.pick(props.manufacturer.resources, sortedKeys);
});
</script>
